import * as mutations from '../../mutation-types'
import { initial_label, } from './initialState'

export const emails_reset_pagination = (store) => {
    store.commit(mutations.EMAILS_RESET_PAGINATION)
}

export const emails_set_gapi = (store, gapi) => {
    store.commit(mutations.EMAILS_SET_GAPI, gapi)
}

export const emails_set_is_signed_in = (store, isSignedIn) => {
    store.commit(mutations.EMAILS_SET_IS_SIGNED_IN, isSignedIn)
}

export const emails_set_label = (store, item = '') => {
    const default_label = initial_label
    let label = item
    label = (((label === 'UNREAD' || label === '') && default_label) || label || initial_label)
    if (label !== store.state.label) {
        emails_reset_pagination(store)
        store.commit(mutations.EMAILS_SET_LABEL, label)
    }
}

export const emails_set_labels = (store, labels) => {
    store.commit(mutations.EMAILS_SET_LABELS, labels)
}

export const emails_set_message = (store, item) => {
    store.commit(mutations.EMAILS_SET_MESSAGE, item)
}

export const emails_set_messages = (store, item) => {
    store.commit(mutations.EMAILS_SET_MESSAGES, item)
}

export const emails_set_pagination = (store, item) => {
    store.commit(mutations.EMAILS_SET_PAGINATION, item)
}

export const emails_set_profile = (store, item) => {
    store.commit(mutations.EMAILS_SET_PROFILE, item)
}

export const emails_set_query = (store, item) => {
    store.commit(mutations.EMAILS_SET_QUERY, item)
}

export const addEmailComment = (_store, params) => {
    return axios.post(`/api/emails/addComment`, params)
        .then(response => {
            return response.data.data
        })
}

export const fetchEmails = (_store, params) => {
    return axios.post(`/api/emails/fetchEmails`, params)
        .then(response => {
            return response.data.data
        })
}

export const fetchEmailByMessageId = (_store, id) => {
    return axios.get(`/api/emails/getByMessageId/${id}`)
        .then(response => {
            return response.data.data
        })
}

export const retrieveEmailByThreadId = (_store, id) => {
    return axios.get(`/api/emails/getByThreadId/${id}`)
        .then(response => {
            return response.data.data
        })
}

export const fetchReferences = (_store, id) => {
    return axios.get(`/api/emails/getReferences/${id}`)
        .then(response => {
            return response.data.data
        })
}

export const saveEmail = (_store, params) => axios.post(`/api/emails`, params)

export const setWork = (_store, params) => axios.post(`/api/emails/setWork`, params).then(res => res.data.data)
